import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import API from "@/api.js";

Vue.config.productionTip = false

import './assets/css/vue.scss';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import Print from 'vue-print-nb';

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.prototype.$api= API;

Vue.use(Print); 
Vue.use(ElementUI);

import VueUeditorWrap from "vue-ueditor-wrap" // ES6 Module
Vue.component('vue-ueditor-wrap', VueUeditorWrap)

// const router = new VueRouter({
//   routes
// })

router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    sessionStorage.removeItem('emailUser');
  }
  let user = JSON.parse(sessionStorage.getItem('emailUser'));
  if (!user && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})


// import o_input from "@/components/o_input.vue"
// Vue.component("o-input", o_input);



//获取并设置appid到根组件
// let p1 = new Promise(
//   resolve => {
//     API.getApplications({
//       onSucess: response => {
//         if (response.data && response.data.errmsg == "ok") {
//           response.data.data.applications.forEach(app => {
//             if (app.id != "km" && app.id != "pm" && app.id != "qm") {
//               resolve(app.id);
//             }
//           });
//         }
//       }
//     });
    
//   }
// );

// let p2 =  new Promise(resolve => {
//   API.getMyProfile(
//     {
//       onSucess: resp => {
//         resolve(resp.data.data);
//       } 
//     }
//   )
// });

// Promise.all([p1, p2]).then(function (result) {
//   new Vue({
//     data: { appid: result[0], user: result[1] },
//     router,
//     store,
//     render: h => h(App)
//   }).$mount('#app')
// });
// let p2 =  new Promise(resolve => {
//   // API.getMyProfile(
//   //   {
//   //     onSucess: resp => {
//   //       resolve(resp.data.data);
//   //     } 
//   //   }
//   // )
//   resolve('99');
// });

// Promise.all([p2]).then( ()=> {
//   debugger
//   new Vue({
//     router,
//     store,
//     render: h => h(App)
//   }).$mount('#app')
// });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

